import router from './router'
import msg from './msg'

import multiTab from './multiTab'
import orgTree from './orgTree'
import QRCode from './QRCode'
import wsReadCard from './wsReadCard'
import tableTips from './tableTips'

import alarmMana from './alarmMana'
import blackList from './blackList'
import dashboard from './dashboard'
import devicesMana from './devicesMana'
import timeConfig from './timeConfig'
import home from './home'
import identificationRecord from './identificationRecord'
import layouts from './layouts'
import logMana from './logMana'
import orgMana from './orgMana'
import personalMana from './personalMana'
import repeatData from './repeatData'
import user from './user'
import userCenter from './userCenter'
import visitorMana from './visitorMana'
import warningMana from './warningMana'

export const zhCN = {
  ...router.zhCN,
  ...msg.zhCN,

  ...multiTab.zhCN,
  ...orgTree.zhCN,
  ...QRCode.zhCN,
  ...wsReadCard.zhCN,
  ...tableTips.zhCN,

  ...alarmMana.zhCN,
  ...blackList.zhCN,
  ...dashboard.zhCN,
  ...devicesMana.zhCN,
  ...timeConfig.zhCN,
  ...home.zhCN,
  ...identificationRecord.zhCN,
  ...layouts.zhCN,
  ...logMana.zhCN,
  ...orgMana.zhCN,
  ...personalMana.zhCN,
  ...repeatData.zhCN,
  ...user.zhCN,
  ...userCenter.zhCN,
  ...visitorMana.zhCN,
  ...warningMana.zhCN
}
export const enUS = {
  ...router.enUS,
  ...msg.enUS,

  ...multiTab.enUS,
  ...orgTree.enUS,
  ...QRCode.enUS,
  ...wsReadCard.enUS,
  ...tableTips.enUS,

  ...alarmMana.enUS,
  ...blackList.enUS,
  ...dashboard.enUS,
  ...devicesMana.enUS,
  ...timeConfig.enUS,
  ...home.enUS,
  ...identificationRecord.enUS,
  ...layouts.enUS,
  ...logMana.enUS,
  ...orgMana.enUS,
  ...personalMana.enUS,
  ...repeatData.enUS,
  ...user.enUS,
  ...userCenter.enUS,
  ...visitorMana.enUS,
  ...warningMana.enUS
}
